import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

export const FIND_CHANNEL_CHECK_FOR_PERIOD: GraphQL = {
	name: 'findChannelCheckForPeriod',
	gql: gql`
      query findChannelCheckForPeriod($companyHotelId: Long!, $startStatDate: LocalDate!, $endStatDate: LocalDate!, $filterInput: MarketStateFilterInput!, $includeStaleChannels: Boolean!) {
          findChannelCheckForPeriod(companyHotelId: $companyHotelId, startStatDate: $startStatDate, endStatDate: $endStatDate, filterInput: $filterInput, includeStaleChannels: $includeStaleChannels) {
              companyHotelId referenceChannel periodFrom periodTo
              channels { key captureDate isStale isPackage notComparedReason }
              closedNights closedEmptyReason
              closedRuns {
                  firstNight lastNight nights directPrice noData
                  closedOn { channel reason }
                  stayLengthOnly { channel nights }
                  alsoSelling { channel price }
              }
              shiftNights shiftEmptyReason
              shiftRuns {
                  firstNight lastNight nights channel refRank chRank setSize refPrice chPrice refVsMedian chVsMedian
                  keyMover { name refDiff chDiff isSuspect }
                  refLadder { name price isMain inLadder isKeyMover isSuspect }
                  chLadder { name price isMain inLadder isKeyMover isSuspect }
              }
          }
      }
	`,
};
